export default __webpack_public_path__ + "static/media/nitron_2.4be7f2dc.jpg";